// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  listingId: __t.u64().primaryKey().name("listing_id"),
  lotId: __t.u64().name("lot_id"),
  label: __t.string(),
  detail: __t.string(),
  priceSov: __t.i64().name("price_sov"),
  stock: __t.i32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
